
module.cC({
    name: 'SlotIndexController',
    inject: ['$scope', 'slots', 'ModelService'],
    data: {
        slots: 'slots',
        statusNames: {
            earned: 'Earned Ed Award',
            finished: 'Hours Completed',
            canceled: 'Slot Canceled',
            on_track: 'On Track',
            not_on_track: 'Not on Track',
            not_started: 'Not Started',
        },
    },

    listen: {
        americorps_slot: {
            create: '_appendSlot',
        }
    },

    methods: {

        _appendSlot: function(slot_id, participant_id) {
            if (participant_id === this.$.student.id) {
                this.ModelService.debouncedGet('americorps_slot', slot_id)
                    .then(this.ModelService.appendToArray(this.slots));
            }
        }

    }
});